import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import PeriodoPresupuestarioImportarReporte from './PeriodoPresupuestarioImportarReporte.jsx'

class PeriodoPresupuestarioImportar extends Component {
    constructor(props) {
        super(props)
        this.ajaxHandler = new AjaxHandler()
        this.state = {
            archivo: null,
            loading: false,
            errores: null,
        }
        this.handleFileChange = this.handleFileChange.bind(this)
        this.handleConfirmar  = this.handleConfirmar.bind(this)
        this.handleCerrar     = this.handleCerrar.bind(this)
    }

    componentDidMount() {
        this.ajaxHandler.subscribe(this)
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe()
    }

    handleFileChange(e) {
        var files = e.target.files
        this.setState({ archivo: files && files.length > 0 ? files[0] : null, errores: null })
    }

    handleConfirmar() {
        var archivo = this.state.archivo
        if (!archivo) return

        var modulo   = this.props.modulo
        var formData = new FormData()
        formData.append('archivo', archivo)

        this.setState({ loading: true, errores: null })

        fetch(Config.get('apiUrlBase') + '/presupuestos/' + modulo + '/importar', {
            method:  'POST',
            headers: { 'Authorization-Token': localStorage.getItem('token') },
            body:    formData,
        })
            .then(function(response) { return response.json().then(function(data) { return { status: response.status, data: data } }) })
            .then(function(result) {
                if (result.status === 200 && result.data && result.data.ok) {
                    if (this.props.onImportSuccess) this.props.onImportSuccess()
                    this.handleCerrar()
                } else if (result.data && result.data.errores) {
                    this.setState({ errores: result.data.errores })
                } else {
                    this.setState({ errores: [{ sheet: '', fila: '', campo: '', mensaje: this.props.intl.formatMessage({ id: 'periodoPresupuestario.importar.error_generico', defaultMessage: 'Error al importar. Verifique el archivo.' }) }] })
                }
            }.bind(this))
            .catch(function() {
                this.setState({ errores: [{ sheet: '', fila: '', campo: '', mensaje: this.props.intl.formatMessage({ id: 'periodoPresupuestario.importar.error_generico', defaultMessage: 'Error al importar. Verifique el archivo.' }) }] })
            }.bind(this))
            .finally(function() {
                this.setState({ loading: false })
            }.bind(this))
    }

    handleCerrar() {
        this.setState({ archivo: null, errores: null, loading: false })
        if (this.props.onClose) this.props.onClose()
    }

    render() {
        var open    = this.props.open
        var loading = this.state.loading
        var errores = this.state.errores
        var archivo = this.state.archivo

        if (!open) return null

        var moduloLabels = { regiones: 'Regiones', subregiones: 'Subregiones', bases: 'Bases' }
        var moduloLabel  = moduloLabels[this.props.modulo] || this.props.modulo

        return (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="modal-dialog modal-lg" style={{ margin: 0, width: '100%', maxWidth: '680px' }}>
                    <div className="modal-content">
                        <div className="modal-header bg-fleet">
                            <h4 className="modal-title text-white">
                                <i className="fa fa-file-excel-o mr-2"></i>
                                <FormattedMessage id="periodoPresupuestario.importar.titulo" defaultMessage="Importar presupuesto" />
                                {' — '}
                                {moduloLabel}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="mb-2 d-flex align-items-center">
                                <label className="btn btn-outline-primary btn-sm mb-0" htmlFor="presupuesto-import-file">
                                    <i className="fa fa-upload mr-1"></i>
                                    <FormattedMessage id="periodoPresupuestario.importar.seleccionar_archivo" defaultMessage="Seleccionar archivo .xlsx" />
                                </label>
                                <input
                                    id="presupuesto-import-file"
                                    type="file"
                                    accept=".xlsx"
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileChange}
                                />
                                {archivo && (
                                    <span className="ml-2 text-muted" style={{ fontSize: '0.9rem' }}>
                                        <i className="fa fa-check-circle text-success mr-1"></i>
                                        {archivo.name}
                                    </span>
                                )}
                            </div>
                            {loading && (
                                <div className="text-center mt-3">
                                    <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#241B3E' }}></i>
                                </div>
                            )}
                            {errores && errores.length > 0 && (
                                <PeriodoPresupuestarioImportarReporte errores={errores} />
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" onClick={this.handleCerrar} disabled={loading}>
                                <i className="fa fa-times mr-1"></i>
                                <FormattedMessage id="periodoPresupuestario.importar.cancelar" defaultMessage="Cancelar" />
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={this.handleConfirmar}
                                disabled={!archivo || loading}
                            >
                                <i className="fa fa-upload mr-1"></i>
                                <FormattedMessage id="periodoPresupuestario.importar.confirmar" defaultMessage="Importar" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioImportar)
